import React from "react";
import { useHistory } from "react-router-dom";

import NavBar from "../../components/NavBar/NavBar";
import ContactUsForm from "../../components/Forms/ContactUs/ContactUs";
import Prefer from "../../components/Prefer/Prefer";
import Offices from "../../components/Offices/Offices";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import Footer from "../../components/Footer/Footer";

import ContactImg from "../../images/contact-us.png";

import "./ContactUs.css";

const ContactUs = () => {
  const history = useHistory();

  return (
    <div className="contactUs">
      <NavBar white />
      <div className="contactUs__hero container d-flex align-end justify-between">
        <div className="d-flex flex-column justify-end h-100 py-20">
          <h2 className="font-large py-40">Contact Us</h2>
          <p className="font-heavy">
            Let's talk about your translations and you will be happy to
            patronise us again
          </p>
          <button
            className="border-0 outline-0 font-big font-bold rounded p-10 my-40"
            onClick={() => history.push("/auth/signup#translator")}
          >
            JOIN AS A TRANSLATOR
          </button>
        </div>
        <img src={ContactImg} alt="" />
      </div>
      <ContactUsForm />
      <Prefer />
      <Offices />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
